import {VotingDescription} from '@modules/voting/models/voting-description';
import {ItemType, VotingPhase, VotingType} from '@modules/voting/models/enums';
import {VotingSection} from '@modules/voting/models/voting-section';
import {IDefaultResponse, ITimedResponse} from '@core/http/models/http-models';
import {CaptchaType} from '@core/services/captcha/captcha';

export class VotingOrigin {
  type: string;
  id: string;
}

export class Voting {
  sections: VotingSection[];
  title;
  description: VotingDescription;
  status;
  settings;
  sponsors;
  pictures;
  origin: VotingOrigin;
  vote_count;
  type: VotingType;

  constructor(init: Partial<Voting>) {
    Object.assign(this, init);

    this.origin = new VotingOrigin();
    Object.assign(this.origin, init.origin);
  }

  get isClosed() {
    return this.status === VotingPhase.CLOSED || this.settings.timestamps.end < Date.now();
  }
}

export class VotingSession {
  _id: string;
  requiredCaptcha: CaptchaType;
  serverTs: number;
  localResponseTime: number;

  static fromResponse(response: VotingSessionResponse): VotingSession {
    const session = new VotingSession();
    session._id = response.data._id;
    session.requiredCaptcha = response.data.captcha.type;
    session.serverTs = response.server_ts;
    session.localResponseTime = Date.now();

    return session;
  }
}

export interface VotingCookieData {
  time: number;
  itemids: string[];
}

export interface VotingSessionResponse extends IDefaultResponse, ITimedResponse {
  _id: string;
  required_captcha: CaptchaType
}

export interface VotingResultDisplayConfig {
  showOnlyTopResults: boolean;
  nrOfVisibleItems: number;
  showVotedItems: boolean;
}

export const ITEM_TYPE_MAP = {
  [ItemType.PLAYER]: {
    singular: 'Spieler',
    plural: 'Spieler'
  },
  [ItemType.TEAM]: {
    singular: 'Team',
    plural: 'Teams'
  },
  [ItemType.UNKNOWN]: {
    singular: 'Option',
    plural: 'Optionen'
  }
};
